import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const Information32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgDark32 : s.svgLight32,
      `svg-icon--${icon}`
    )}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={`${icon}-32`}
  >
    <path
      d="M16 5.25c5.937 0 10.75 4.813 10.75 10.75S21.937 26.75 16 26.75 5.25 21.937 5.25 16 10.063 5.25 16 5.25zm0 1.5a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zm.75 7.432v7.665h-1.5v-7.665h1.5zM16 9.636a1.364 1.364 0 11-.001 2.729A1.364 1.364 0 0116 9.636z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

export default Information32;
